import { CanActivate } from '@angular/router/src/utils/preactivation';
import { Menu } from './menu.model';

export const verticalMenuItems = [ 
    //       Id   Key,       ,Title,             Route,          Href,   Icon,           Target, HasSubmenu, ParentId
    new Menu(1,  'DASH',     'Dashboard',        'dashboard',    null,   'dashboard',    null,   false,      0),
    new Menu(2,  'FACT',     'Facturas',         'facturas',     null,   'dashboard',    null,   false,      0),
    new Menu(3,  'USUA',     'Usuarios',         'usuarios',     null,   'dashboard',    null,   false,      0),
]

export const horizontalMenuItems = [
    new Menu (1, 'DASH', 'Dashboard', '/', null, 'dashboard', null, false, 0),
]